module.exports = __webpack_public_path__ + "assets/svg/Icons/32/task-yellow-04d8ca.svg";